<template>
    <div class="fhv-centent"  v-loading="loading" >
        <h4 class="title-topic">Share Folder</h4>

        <el-form :model="From" 
            ref="From" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
             <el-form-item   label="Folder Path:" prop="path">
                <el-select v-model="From.path" placeholder="Please select" style="width: 100%">
                    <el-option v-for="item in pathLists" :key="item.value" :label="item.value" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item   label="Owner:" prop="owner">
             <el-select v-model="From.owner" placeholder="Please select" style="width: 100%">
                    <el-option v-for="item in ownerLists" :key="item.value" :label="item.value" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item   label="Permission" prop="permission">
             <el-select v-model="From.permission" placeholder="Please select" style="width: 100%">
                    <el-option value="0" label="Read Only"></el-option>
                    <el-option value="1" label="Read Write"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item   label="" prop="passAgain">
              <el-button type="primary" @click="add">Apply Changes</el-button>
            </el-form-item>
        </el-form>
      
        <p>Current Account Table:</p>
        <el-table :data="tableData" stripe style="width: 100%" border class="fhv-table">  
             <el-table-column prop="name" width="150px" label="Folder Name"></el-table-column>  
             <el-table-column prop="path" label="Folder Path"></el-table-column>
             <el-table-column prop="owner" label="Owner"></el-table-column>
             <el-table-column prop="permission" label="Permission"></el-table-column>
             <el-table-column fixed="right" label="Method" width="120">
                <template slot-scope="scope">
                    <el-button
                    @click.native.prevent="deleteRow(scope.$index,tableData)"
                    type="text"
                    size="small">
                    Delete
                    </el-button>
                </template>
             </el-table-column>
        </el-table>

        <div class="fhv-scan">
             <el-button type="primary" @click="deleteRow('all')" :disabled="$G_DEVICE_CFG.isReadOnly">Delete_All</el-button>
             <el-button type="primary" @click="getData" :disabled="$G_DEVICE_CFG.isReadOnly">reset</el-button>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      loading: false,
      From: {
        path: "",
        owner: "",
        permission: "0"
      },
      pathLists: [],
      ownerLists: [],
      tableData: [
        /*  {
          user: "admin",
        } */
      ]
    };
  },
  methods: {
    deleteRow(index, rows) {
      if (index == "all") {
        this.del(index);
      } else {
        this.del(index + 1);
      }
    },
    del(index) {
      if (index == "all") {
          var postData={
              Delete_All:"Delete All",
              submit_url: "/disksharefolder.htm"
          }
      } else {
        var postData = {
          Delete_Selected: "Delete Selected",
          submit_url: "/disksharefolder.htm"
        };
        var name = `select${index}`;
        postData[name] = "ON";
      }

      this.loading = true;
      axios.post("/boafrm/setformDiskCreateShare", postData).then(res => {
        this.loading = false;
        this.getData();
      });
    },
    getData() {
      this.loading = true;
      axios.post("/boafrm/getShareFolderStatus").then(res => {
        this.loading = false;
     
        let data = res.data;
        this.data = data;
        this.pathLists = [];
        this.ownerLists = [];
        this.tableData = [];
        this.From.path=data.path[0].value;
        this.From.owner=data.owner[0].value;
        for (var i = 0; i < data.path.length - 1; i++) {
          this.pathLists.push({ value: data.path[i].value });
        }
        for (var i = 0; i < data.owner.length - 1; i++) {
          this.ownerLists.push({ value: data.owner[i].value });
        }

        for (var i = 0; i < data.tableData.length - 1; i++) {
          this.tableData.push({
            name: data.tableData[i].name,
            path: data.tableData[i].path,
            owner: data.tableData[i].owner,
            permission: data.tableData[i].permission
          });
        }
      });
    },
    add() {
      let postData = {
        folderpath: this.From.path,
        ownerUser: this.From.owner,
        permission: this.From.permission,
        Add_Share_Folder: "Apply Changes",
        submit_url: "/disksharefolder.htm"
      };
      for (var i = 0; i < this.data.tableData.length - 1; i++) {
        if (postData.ownerUser == this.data.tableData[i].owner) {
          this.$message.error("Share Folder Name is already exist,Please choose another Share Folder Name!");
          return 
        }
      }
      this.loading = true;
      axios.post("/boafrm/setformDiskCreateShare", postData).then(res => {
        this.loading = false;
        this.$message.success(res.data.msg);
        this.getData();
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>




